import React, { useEffect, useState } from 'react'
import { Col, Modal, Row, Form } from 'react-bootstrap';
// import { Form } from 'react-router-dom';
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import { useParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import axios from '../../API/axios';

const EditExperienceRole = ({ userDataId, getUserCv, handleCloseEditExperienceRole, showEditExperienceRole, experienceRoleData, experienceData }) => {
    console.log('experienceRoleData', experienceRoleData);
    const sessionId = localStorage.getItem("sessionId");
    const userType = localStorage.getItem("userType");
    const { CandidateId } = useParams();
    const [role, setRole] = useState('');
    const [display, setDisplay] = useState(false);

    const [formChanged, setFormChanged] = useState(false); // Track if form is modified
    const [isSubmitting, setIsSubmitting] = useState(false);
    // Handle changes and mark form as modified
    const handleFieldChange = (setter, value) => {
        setter(value);
        setFormChanged(true); // Enable Submit button
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setDisplay(true);
        setIsSubmitting(true); // Disable the button during submission
        const body = {
            sessionId: sessionId,
            userDataId: userDataId,
            userType: userType,
            instnCnddtID: CandidateId === "Candidate" ? null : CandidateId,
            expId: experienceData.usrDataExpId,
            role: role,
            expRoleId: experienceRoleData.usrDataExpRlId
        };
        console.log("body", body);
        if (role === '') {
            toast.error('Please fill all the required fields');
            setIsSubmitting(false); // Re-enable the button if validation fails
        } else {
            try {
                const res = await axios.post("/Resume/UpdateExperienceRole", body);
                toast.success(res.data.message);
                handleCloseEditExperienceRole();
                getUserCv();
                setDisplay(false)
                setFormChanged(false); // Disable the button after update
            } catch (error) {
                if (error.response && error.response.status === 404) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.response?.data?.message || "An error occurred");
                }
            }finally {
                setIsSubmitting(false); // Ensure the button is re-enabled in case of failure
              }
        }
    };

    useEffect(() => {
        if (experienceRoleData) {
            setRole(experienceRoleData.role)
        }
    }, [experienceRoleData])

    return (
        <Modal show={showEditExperienceRole} onHide={handleCloseEditExperienceRole} centered size="lg">
            <Modal.Header>
                <Modal.Title>Update experience role</Modal.Title>
                <CloseSharpIcon className="pointer" onClick={handleCloseEditExperienceRole} />
            </Modal.Header>
            <Modal.Body className="settings">
                <Row>
                    <Col md={12}>
                        <Form.Group controlId="grade">
                            <Form.Label className="class-type">Role<span style={{ color: "red" }}> *</span>

                            </Form.Label>
                            <Form.Control
                                type="text"
                                value={role}
                                // onChange={(e) => setRole(e.target.value)}
                                onChange={(e) => handleFieldChange(setRole, e.target.value)} // Track changes
                                placeholder="Enter Role"
                                className='Normal-Input-Fill'
                            />
                            {display && !role ? (
                                <span className="error_msg_lbl">Add role </span>
                            ) : null}
                        </Form.Group>
                    </Col>

                </Row>

                <div className="d-flex justify-content-end mt-4">
                    <div className="add-class-submit-button mt-4 d-flex justify-content-center">
                        <div className="khojPrimaryBtn ms-3"
                         onClick={handleSubmit}
                         style={{cursor: formChanged ? "pointer" : "default"}}
                        >
                            <a href="#/"
                                // onClick={handleSubmit}
                                className={`btn  ${!formChanged || isSubmitting ? "disabled" : "enabled"}`}
                                // onClick={!formChanged || isSubmitting ? (e) => e.preventDefault() : handleSubmit}
                                disabled={!formChanged || isSubmitting}
                                style={{ pointerEvents: formChanged ? "auto" : "none", border: "none" }}
                            >
                                Submit
                            </a>
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default EditExperienceRole